import React from 'react';
import Spinner from '../SalesData/Spinner';

const ProgressBar = ({ label, current, total }) => {
    const percent = total === 0 ? 0 : Math.round((current / total) * 100);

    return (
        <div style={{ margin: '0.75rem 0 0' }}>
            <div style={{ marginBottom: '0.4rem', fontSize: '0.85rem' }}>
                <Spinner />{label}{total > 0 && `: ${current} av ${total}`}
            </div>
            <div
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={total}
                aria-valuenow={current}
                style={{ height: '0.6rem', backgroundColor: '#e6e6e6', borderRadius: '0.3rem', overflow: 'hidden' }}
            >
                <div style={{ width: `${percent}%`, height: '100%', backgroundColor: '#111', transition: 'width 0.2s' }} />
            </div>
        </div>
    );
};

export default ProgressBar;
